import axios from '@/plugins/axios';
import downloadFile from '@/helpers/downloadFile';
import ErrorHandle from '@/helpers/errors/errorHandle';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  autoLoadingData: false,
  autosListData: {},
  autosStatuses: [],
  autosBrands: [],
  autosTypes: [],
  autosFuels: [],
  autosCompanies: [],
  autosInvestors: [],
  autosLocations: [],
  autosResponsibles: [],
  autosState: {},
  autoBrand: {
    id: null,
    title: null,
  },
  autoModel: {
    id: null,
    title: null,
  },
  autoBrandId: null,
  autoTitle: '',
  autoHistoryData: {},
  autoRentsData: {},
  autoRatesData: [],
  autoCurrentStateFirstFilter: {
    defaultState: true,
    date: '',
    type: null,
    acceptedByManager: false,
  },
  autoCurrentStateSecondFilter: {
    defaultState: false,
    date: '',
    type: null,
    acceptedByManager: false,
  },
  autoCurrentStateFirstLoader: false,
  autoCurrentStateSecondLoader: false,
  autoCurrentStateFirstData: {
    status: null,
    images: [],
    properties: [],
    damage: {
      title: null,
      images: [],
    },
    refuseReason: {
      title: null,
      images: [],
    },
  },
  autoCurrentStateSecondData: {
    status: null,
    images: [],
    properties: [],
    damage: {
      title: null,
      images: [],
    },
    refuseReason: {
      title: null,
      images: [],
    },
  },
  insuranceInspection: {
    list: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 25,
  },
  internalMaintenance: {
    list: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 25,
  },
  maintenanceHistory: {
    list: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 25,
  },
  maintenanceTypes: [],
  stateDates: [],
  stateByDate: [],
};

/* eslint-disable */
const getters = {
  getAutoLoadingData: (state) => state.autoLoadingData,
  getAutosListData: (state) => state.autosListData,
  getAutosStatuses: (state) => state.autosStatuses,
  getAutosBrands: (state) => state.autosBrands,
  getAutosTypes: (state) => state.autosTypes,
  getFuelTypes: (state) => state.autosFuels,
  getAutosCompanies: (state) => state.autosCompanies,
  getAutosInvestors: (state) => state.autosInvestors,
  getAutosLocations: (state) => state.autosLocations,
  getAutosResponsibles: (state) => state.autosResponsibles,
  getAutoBrand: (state) => state.autoBrand,
  getAutoBrandId: (state) => state.autoBrandId,
  getAutoModel: (state) => state.autoModel,
  getAutoTitle: (state) => state.autoTitle,
  getAutoHistoryData: (state) => state.autoHistoryData,
  getAutoRentsData: (state) => state.autoRentsData,
  getAutoCurrentStateFirstFilter: (state) => state.autoCurrentStateFirstFilter,
  getAutoCurrentStateSecondFilter: (state) =>
    state.autoCurrentStateSecondFilter,
  getAutoCurrentStateFirstLoader: (state) => state.autoCurrentStateFirstLoader,
  getAutoCurrentStateSecondLoader: (state) =>
    state.autoCurrentStateSecondLoader,
  getAutoCurrentStateFirstData: (state) => state.autoCurrentStateFirstData,
  getAutoCurrentStateSecondData: (state) => state.autoCurrentStateSecondData,
};
/* eslint-enable */

const mutations = {
  setAutoLoadingData(state, data) {
    state.autoLoadingData = data;
  },
  setAutosListData(state, data) {
    state.autosListData = data;
  },
  setAutosStatuses(state, data) {
    state.autosStatuses = data;
  },
  setAutosBrands(state, data) {
    state.autosBrands = data;
  },
  setAutosTypes(state, data) {
    state.autosTypes = data;
  },
  setAutosFuels(state, data) {
    state.autosFuels = data;
  },
  setAutosCompanies(state, data) {
    state.autosCompanies = data;
  },
  setAutosInvestors(state, data) {
    state.autosInvestors = data;
  },
  setAutosLocations(state, data) {
    state.autosLocations = data;
  },
  setAutosResponsibles(state, data) {
    state.autosResponsibles = data;
  },
  setAutosState(state, data) {
    state.autosState = data;
  },
  clearAutosProperties(state) {
    state.autosStatuses = [];
    state.autosBrands = [];
    state.autosTypes = [];
    state.autosCompanies = [];
    state.autosInvestors = [];
    state.autosLocations = [];
    state.autosResponsibles = [];
  },
  setAutoFormBrand(state, data) {
    state.autoBrand = data;
    state.autoBrandId = data.id;
  },
  setAutoFormModel(state, data) {
    state.autoModel = data;
  },
  setAutoTitle(state, data) {
    state.autoTitle = data;
  },
  setAutoHistoryData(state, data) {
    state.autoHistoryData = data;
  },
  setAutoRentsData(state, data) {
    state.autoRentsData = data;
  },
  setAutoRatesData(state, data) {
    state.autoRatesData = data;
  },
  setAutoCurrentStateFirstFilter(state, data) {
    state.autoCurrentStateFirstFilter = data;
  },
  setAutoCurrentStateSecondFilter(state, data) {
    state.autoCurrentStateSecondFilter = data;
  },
  clearAutoCurrentStateFilter(state, filter) {
    if (filter === 1) {
      state.autoCurrentStateFirstFilter = {
        defaultState: true,
        date: '',
        type: null,
        acceptedByManager: false,
      };
    }
    if (filter === 2) {
      state.autoCurrentStateSecondFilter = {
        defaultState: false,
        date: '',
        type: null,
        acceptedByManager: false,
      };
    }
  },
  setAutoCurrentStateFirstLoader(state, data) {
    state.autoCurrentStateFirstLoader = data;
  },
  setAutoCurrentStateSecondLoader(state, data) {
    state.autoCurrentStateSecondLoader = data;
  },
  setAutoCurrentStateLoader(state, data) {
    if (data.loader === 1) {
      state.autoCurrentStateFirstLoader = data.state;
    }
    if (data.loader === 2) {
      state.autoCurrentStateSecondLoader = data.state;
    }
  },
  setAutoCurrentStateData(state, data) {
    if (data.filter === 1) {
      state.autoCurrentStateFirstData = data.filterData;
    }
    if (data.filter === 2) {
      state.autoCurrentStateSecondData = data.filterData;
    }
  },
  clearAutoCurrentStateData(state, data) {
    if (data === 1) {
      state.autoCurrentStateFirstData = {
        status: null,
        images: [],
        properties: [],
        damage: {
          title: null,
          images: [],
        },
        refuseReason: {
          title: null,
          images: [],
        },
      };
    }
    if (data === 2) {
      state.autoCurrentStateSecondData = {
        status: null,
        images: [],
        properties: [],
        damage: {
          title: null,
          images: [],
        },
        refuseReason: {
          title: null,
          images: [],
        },
      };
    }
  },

  setInsuranceInspection(state, payload) {
    state.insuranceInspection.list = payload.list;
    state.insuranceInspection.currentPage = payload.currentPage;
    state.insuranceInspection.lastPage = payload.lastPage;
    state.insuranceInspection.perPage = payload.perPage;
  },

  setInternalMaintenance(state, payload) {
    state.internalMaintenance.list = payload.list;
    state.internalMaintenance.currentPage = payload.currentPage;
    state.internalMaintenance.lastPage = payload.lastPage;
    state.internalMaintenance.perPage = payload.perPage;
  },

  setMaintenanceHistory(state, payload) {
    state.maintenanceHistory.list = payload.list;
    state.maintenanceHistory.currentPage = payload.currentPage;
    state.maintenanceHistory.lastPage = payload.lastPage;
    state.maintenanceHistory.perPage = payload.perPage;
  },

  setMaintenanceTypes(state, payload) {
    state.maintenanceTypes = payload;
  },

  setStateDates(state, payload) {
    state.stateDates = payload;
  },
};

/* eslint-disable no-unused-vars */
const actions = {
  async fetchAutosProperties({ commit }) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.get('/cars/properties', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const {
        status,
        state,
        location,
        brand,
        type,
        fuel,
        company,
        investor,
        responsible,
      } = data.data.data.properties;
      commit('setAutosStatuses', status);
      commit('setAutosLocations', location);
      commit('setAutosBrands', brand);
      commit('setAutosTypes', type);
      commit('setAutosFuels', fuel);
      commit('setAutosCompanies', company);
      commit('setAutosInvestors', investor);
      commit('setAutosResponsibles', responsible);
      commit('setAutosState', state);
      commit('global/setLoader', false, { root: true });
      return data;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  async fetchAutosListData({ commit }, credentials) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const searchString = credentials.searchString
        ? encodeURIComponent(credentials.searchString)
        : '';
      const page = credentials.page ? credentials.page : '';
      const autoStatus = credentials.autoStatus ? credentials.autoStatus : '';
      const sortField = credentials.sortField ? credentials.sortField : '';
      const sortDirection = credentials.sortDirection
        ? credentials.sortDirection
        : '';
      const rentRate = credentials.rentRate ? credentials.rentRate : '';
      const carParkId = credentials.carParkId ? credentials.carParkId : '';
      const brandId = credentials.brandId ? credentials.brandId : '';
      const modelId = credentials.modelId ? credentials.modelId : '';
      const weekendSchedule = credentials.weekendSchedule
        ? credentials.weekendSchedule
        : '';

      const data = await axios.get(
        `/cars?page=${page}&searchString=${searchString}&status=${autoStatus}&orderCol=${sortField}&orderType=${sortDirection}&rentRate=${rentRate}&carParkId=${carParkId}&brandId=${brandId}&modelId=${modelId}&weekendSchedule=${weekendSchedule}`,
        {
          headers: { Authorization: `Bearer ${token}`, Lang: lang },
        },
      );

      const autosListData = {
        ...data.data.data.cars,
        num: enumerateArray(
          data.data.data.cars.items,
          data.data.data.cars.currentPage,
          data.data.data.cars.perPage,
        ),
      };

      commit('setAutosListData', autosListData);
      commit('global/setLoader', false, { root: true });
      return autosListData;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },

  async downloadList(_, { params, name }) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get('cars', {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params: {
          ...params,
          export: 1,
        },
      });

      downloadFile(data, name);

      return { success: true };
    } catch {
      return { error: true };
    }
  },

  async fetchBrandsData({ commit }, searchString) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.get(
        `/cars/properties/autocomplete?type=brands&title=${searchString}`,
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      if (response.data.success && response.data.data.result) {
        return response.data.data.result;
      }
      return [];
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async fetchAutoTitle({ commit }, credentials) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.get(`/cars/${credentials.id}/title`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const autoTitle = data.data.data.title;

      commit('setAutoTitle', autoTitle);
      return autoTitle;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async fetchModelsData({ commit }, searchObj) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.get(
        `/cars/properties/autocomplete?type=models&brandId=${searchObj.brandId}&title=${searchObj.search}`,
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      if (response.data.success && response.data.data.result) {
        return response.data.data.result;
      }
      return [];
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async createBrand({ commit }, brand) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const outData = {
        type: 'brands',
        title: brand,
      };
      const response = await axios.post('/cars/properties', outData, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      if (response.data.success && response.data.data.id) {
        return response.data.data.id;
      }
      return null;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async createModel({ commit }, modelData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const outData = {
        type: 'models',
        brandId: modelData.brandId,
        title: modelData.title,
      };
      const response = await axios.post('/cars/properties', outData, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      if (response.data.success && response.data.data.id) {
        return response.data.data.id;
      }
      return null;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async createAuto({ commit }, autoData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.post('/cars', autoData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Lang: lang,
        },
      });

      return data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async uploadFiles(_, { formData, autoId }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.post(`/cars/${autoId}/files`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          Lang: lang,
        },
      });

      return data.data.fileId;
    } catch (error) {
      return error;
    }
  },
  async downloadFile(_, { id, name }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.get(`/cars/files/${id}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          Lang: lang,
        },
      });

      downloadFile(data.data, name, 'application/octet-stream');

      return data;
    } catch (error) {
      return error;
    }
  },
  async deleteFile(_, id) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.delete(`/cars/files/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Lang: lang,
        },
      });

      return { success: true };
    } catch (error) {
      return error;
    }
  },
  async editAuto({ commit }, autoData) {
    try {
      const { autoId } = autoData;
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.put(`/cars/${autoId}`, autoData.data, {
        headers: {
          Authorization: `Bearer ${token}`,
          Lang: lang,
          'Content-type': 'application/json',
        },
      });

      return data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async fetchAutoHistoryData({ commit }, credentials) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const page = credentials.page ? credentials.page : '';
      const autoId = credentials.autoId ? credentials.autoId : '';
      const data = await axios.get(`/cars/${autoId}/history/?page=${page}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const autoHistoryData = {
        ...data.data.data.history,
        items: enumerateArray(
          data.data.data.history.items,
          data.data.data.currentPage,
          data.data.data.history.perPage,
        ),
      };

      commit('setAutoHistoryData', autoHistoryData);
      commit('global/setLoader', false, { root: true });
      return autoHistoryData;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  async fetchAutoRentsData({ commit }, credentials) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const page = credentials.page ? credentials.page : '';
      const autoId = credentials.autoId ? credentials.autoId : '';
      const data = await axios.get(`/rents?page=${page}&carId=${autoId}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const autoRentsData = {
        ...data.data.data.rents,
        items: enumerateArray(
          data.data.data.rents.items,
          data.data.data.rents.currentPage,
          data.data.data.rents.perPage,
        ),
      };

      commit('setAutoRentsData', autoRentsData);
      commit('global/setLoader', false, { root: true });
      return autoRentsData;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  async fetchAutoStateDates({ commit }, { autoId }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get(`cars/states/${autoId}/dates`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      commit('setStateDates', data.data);

      return data;
    } catch (error) {
      return error;
    }
  },
  async fetchAutoStateByDate(_, { autoId, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get(`cars/state/${autoId}/date`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      return data.data;
    } catch (error) {
      return error;
    }
  },
  // async fetchAutoStateData({ commit }, credentials) {
  //   try {
  //     commit('setAutoCurrentStateLoader', {
  //       loader: credentials.filterNumber,
  //       state: true,
  //     });

  //     const token = localStorage.getItem('token') || '';
  //     const lang = localStorage.getItem('language') || '';
  //     const autoId = credentials.autoId ? credentials.autoId : '';
  //     const type = credentials.filter.type ? credentials.filter.type : '';
  //     const date = credentials.filter.date ? credentials.filter.date : '';
  //     const defaultState = credentials.filter.defaultState
  //       ? credentials.filter.defaultState
  //       : false;
  //     const acceptedByManager = credentials.filter.acceptedByManager
  //       ? credentials.filter.acceptedByManager
  //       : false;
  //     const data = await axios.get(
  // eslint-disable-next-line
  //       `/cars/${autoId}/state/?type=${type}&date=${date}&defaultState=${defaultState}&acceptedByManager=${acceptedByManager}`,
  //       { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
  //     );

  //     const stateData = data.data.data;

  //     commit('setAutoCurrentStateData', {
  //       filter: credentials.filterNumber,
  //       filterData: stateData,
  //     });
  //     commit('setAutoCurrentStateLoader', {
  //       loader: credentials.filterNumber,
  //       state: false,
  //     });
  //     return stateData;
  //   } catch (error) {
  //     commit('setAutoCurrentStateLoader', {
  //       loader: credentials.filterNumber,
  //       state: false,
  //     });
  //     throw ErrorHandle(error, this);
  //   }
  // },
  async fetchAutoLastRentOptions({ commit }, autoId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';

      const data = await axios.get(`/cars/${autoId}/last-rent-options`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const lastRentOptions = data.data.data;

      commit('setAutoCurrentStateSecondFilter', {
        defaultState: false,
        date: lastRentOptions.date ? lastRentOptions.date : '',
        type: lastRentOptions.type ? lastRentOptions.type : null,
        acceptedByManager: lastRentOptions.acceptedByManager
          ? lastRentOptions.acceptedByManager
          : false,
      });
      return lastRentOptions;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async fetchAutoData({ commit }, autoId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.get(`/cars/${autoId}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async fetchAutoRates({ commit }, autoId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get(`/cars/${autoId}/rete_history`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      commit('setAutoRatesData', enumerateArray(data.data.rent_rates));

      return data;
    } catch (error) {
      return error;
    }
  },
  async validateAutoNumber(_, number) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get(`/cars/is_number/${number}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { isExisting: data.data };
    } catch (error) {
      return error;
    }
  },
  async fetchInsuranceInspectionList({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('/cars/insurance', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const list = enumerateArray(
        data.data.items,
        data.data.currentPage,
        data.data.perPage,
      );

      commit('setInsuranceInspection', {
        list,
        currentPage: data.data.currentPage,
        lastPage: data.data.lastPage,
        perPage: data.data.perPage,
      });

      return data;
    } catch (error) {
      return error;
    }
  },
  async updateInsuranceInfo(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post(`/cars/${id}/insurance`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },
  async fetchInternalMaintenance({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('internal_maintenance', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const list = enumerateArray(
        data.data.items.data,
        data.data.items.current_page,
        data.data.items.per_page,
      );

      commit('setInternalMaintenance', {
        list,
        currentPage: data.data.items.current_page,
        lastPage: data.data.items.last_page,
        perPage: data.data.items.per_page,
      });
      return data;
    } catch (error) {
      return error;
    }
  },
  async updateInternalMaintenanceItem(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`internal_maintenance/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },
  async fetchMaintenanceHistory({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('internal_maintenance_log', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const list = enumerateArray(
        data.data.items.items,
        data.data.items.currentPage,
        data.data.items.perPage,
      );

      commit('setMaintenanceHistory', {
        list,
        currentPage: data.data.items.currentPage,
        lastPage: data.data.items.lastPage,
        perPage: data.data.items.perPage,
      });

      return data;
    } catch (error) {
      return error;
    }
  },

  async downloadMaintenanceHistory({ commit }, { params, name }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('internal_maintenance_log', {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params: {
          ...params,
          export: 1,
        },
      });

      downloadFile(data, name);

      return data;
    } catch (error) {
      return error;
    }
  },

  async updateMaintenanceHistoryItem(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`internal_maintenance_log/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async fetchMaintenanceTypes({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('internal_maintenance_log/types', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const types = Object.entries(data.data).map(([id, name]) => ({
        id,
        name,
      }));

      commit('setMaintenanceTypes', types);
      return data;
    } catch (error) {
      return error;
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
